import * as React from "react";
import {
  FaCar,
  FaCarCrash,
  FaLock,
  FaQuestionCircle,
  FaSign
} from "react-icons/fa";
import InvitePage from "../pages/invite";
import LoginPage from "../pages/login";
import RecoverPage from "../pages/recover";
import SignupPage from "../pages/signup";
import SignupCompanyPage from "../pages/signup_company";
import HomePage from "../pages/home";
import FormsPage from "../pages/forms";
import { FaCalendar, FaChartLine, FaCreditCard, FaGears, FaNetworkWired, FaQuestion, FaUpwork, FaUsers } from "react-icons/fa6";
import OpportunitiesPage from "../pages/opportunities";
import OpportunityPage from "../pages/opportunity";
import ApplyOpportunity from "../pages/apply_opportunity";
import CarsPage from "../pages/cars";
import MaintenancesPage from "../pages/maintenances";
import ContractsPage from "../pages/contracts";
import SettingsPage from "../pages/settings";
import CustomersPage from "../pages/customers";
import CalendarPage from "../pages/calendar";

export interface RouteProps {
  title: string;
  key: string;
  icon?: React.ReactNode;
  url: string;
  component: React.ReactNode;
  private?: boolean;
  menu?: boolean;
  condition?: (data: { user: any; role: any; }) => boolean;
}
const routes: RouteProps[] = [
  {
    title: "Login",
    key: "login",
    icon: <FaLock />,
    url: "/login",
    component: <LoginPage />,
  },
  {
    title: "Signup",
    key: "signup",
    icon: <FaSign />,
    url: "/signup",
    component: <SignupPage />,
  },
  {
    title: "Company Signup",
    key: "company_signup",
    icon: <FaSign />,
    url: "/company/signup",
    component: <SignupCompanyPage />,
  },
  // {
  //   title: "Client Signup",
  //   key: "signup-customer",
  //   icon: <FaSign />,
  //   url: "/signup/customer",
  //   component: <SignupPage customer />,
  // },
  {
    title: "Invite",
    key: "invite",
    url: "/invite/:key",
    component: <InvitePage />,
  },
  // {
  //   title: "Apply Opportunity",
  //   key: "apply",
  //   url: "/apply/:id",
  //   component: <ApplyOpportunity />,
  // },
  {
    title: "Recover Password",
    key: "recover",
    url: "/recover/:key",
    component: <RecoverPage />,
  },
  {
    title: "Home",
    key: "home",
    url: "/",
    icon: <FaChartLine />,
    menu: true,
    private: true,
    component: <HomePage />,
  },
  {
    title: "Agenda",
    key: "calendar",
    url: "/agenda",
    icon: <FaCalendar />,
    menu: true,
    private: true,
    component: <CalendarPage />,
  },
  {
    title: "Frota",
    key: "cars",
    url: "/frota",
    icon: <FaCar />,
    menu: true,
    private: true,
    component: <CarsPage />,
  },
  {
    title: "Clientes",
    key: "customers",
    url: "/clientes",
    icon: <FaUsers />,
    menu: true,
    private: true,
    component: <CustomersPage />,
  },
  {
    title: "Contratos",
    key: "contracts",
    url: "/contratos",
    icon: <FaCreditCard />,
    menu: true,
    private: true,
    component: <ContractsPage />,
  },
  {
    title: "Manutenções",
    key: "maintenance",
    url: "/manutencoes",
    icon: <FaCarCrash />,
    menu: true,
    private: true,
    component: <MaintenancesPage />,
  },
  {
    title: "Configurações",
    key: "settings",
    url: "/configuracoes",
    icon: <FaGears />,
    menu: true,
    private: true,
    component: <SettingsPage />,
  },
  // {
  //   title: "Opportunities",
  //   key: "opportunities",
  //   url: "/opportunities",
  //   icon: <FaNetworkWired />,
  //   menu: false,
  //   private: true,
  //   component: <OpportunitiesPage />,
  // },
  // {
  //   title: "Opportunity",
  //   key: "opportunity",
  //   url: "/opportunities/:id",
  //   icon: <FaNetworkWired />,
  //   menu: false,
  //   private: true,
  //   component: <OpportunityPage />,
  //   condition: ({ role }) => !!role
  // },
  // {
  //   title: "Forms",
  //   key: "forms",
  //   url: "/forms",
  //   icon: <FaQuestionCircle />,
  //   menu: true,
  //   private: true,
  //   component: <FormsPage />,
  //   condition: ({ role }) => !!role
  // },
  // {
  //   title: "Share",
  //   key: "public",
  //   url: "/:key",
  //   menu: false,
  //   private: false,
  //   component: <PublicPage />,
  // },
];

export default routes;
